import React from 'react';
import { FileExplorerContext } from '../components/FileExplorer/Context/FileExplorerContext';

export const useFileExplorerContext = () => {
  const context = React.useContext(FileExplorerContext);
  if (!context) {
    throw new Error('useTreeContext must be used within a FileTreeContextProvider');
  }
  return context;
};
